import Flickity from './FlickityExtended';

const ACTIVE_AUTOPLAY_CLASS = 'slider--active-autoplay';
const HAS_AUTOPLAY_CLASS = 'slider--has-autoplay';
const NO_AUTOPLAY_CLASS = 'slider--no-autoplay';
const INIT_CLASS = 'slider--init';

// Remove autoplay class on stop
Flickity.prototype.stopPlayer = function () {
    this.player.stop();
    this.element.classList.remove(ACTIVE_AUTOPLAY_CLASS);
};

const STRINGS = document.body.dataset.slider.split(',');

// Set additional default values
const DEFAULTS = {
    pauseAutoPlayOnHover: false,
    imagesLoaded: true,
    pageDotAriaLabel: STRINGS[0],
    previousAriaLabel: STRINGS[1],
    nextAriaLabel: STRINGS[2],
    on: {
        ready: function () {
            if (this.options.autoPlay) {
                this.element.classList.add(HAS_AUTOPLAY_CLASS);
                this.element.classList.add(ACTIVE_AUTOPLAY_CLASS);
                setTimeout(() => {
                    this.element.classList.add(INIT_CLASS);
                }, 10);
            } else {
                this.element.classList.add(NO_AUTOPLAY_CLASS);
            }
        },
    },
    arrowShape:
        'M99.2013 49.7035c0-3.1992-2.599-5.7939-5.7981-5.7852l-71.1405.0302c-.3886.0043-.7426-.2331-.8937-.5915a.972.972 0 0 1 .2159-1.0534l32.207-32.2114c2.2623-2.2622 2.2623-5.932 0-8.1942-2.2622-2.2623-5.932-2.2623-8.1942 0L4.6265 42.8692c-1.809 1.8132-2.8278 4.2741-2.8278 6.8343 0 2.5601 1.0232 5.021 2.8321 6.83l40.9755 40.9711c2.258 2.2623 5.932 2.2623 8.1943 0 2.258-2.2623 2.258-5.9277-.0043-8.19l-32.125-32.125a.9806.9806 0 0 1-.203-1.0534c.1554-.3626.5051-.5958.8937-.5958l71.0498-.0345c1.5974-.0043 3.0437-.6519 4.0928-1.701 1.0491-1.0491 1.6967-2.4997 1.6967-4.1014z',
};

Object.assign(Flickity.defaults, DEFAULTS);

// Add localized labels with this duck-punch code
// https://metafizzy.co/blog/duck-punching-prototype/

let addDots = Flickity.PageDots.prototype.addDots;
Flickity.PageDots.prototype.addDots = function () {
    addDots.apply(this, arguments);
    let ariaLabel = this.parent.options.pageDotAriaLabel;
    this.dots.forEach(function (dot, i) {
        let label = ariaLabel.replace('%n', i + 1);
        dot.setAttribute('aria-label', label);
    });
};

let _createButton = Flickity.PrevNextButton.prototype._create;
Flickity.PrevNextButton.prototype._create = function () {
    _createButton.apply(this, arguments);
    let optionName = this.isPrevious ? 'previous' : 'next';
    let label = this.parent.options[optionName + 'AriaLabel'];
    this.element.setAttribute('aria-label', label);
};

export default Flickity;
